import React from 'react';

export const ChevronLeftIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-chevron-left"
      style={props.style}
    />
  );
};
